import * as Highcharts from 'highcharts'
import 'highcharts/highcharts-more'
import 'highcharts/modules/exporting'
import i18next from 'i18next'

const styles = {
  true: {
    background: '#1d1d1d',
    textColor: 'white',
  },
  false: {
    background: 'white',
    textColor: 'black',
  },
}

export function getHighchartOptions(actionCard, isDark) {
  if (!actionCard || !actionCard.useScoringDimensions) {
    return null
  }

  const scoringDimensions = actionCard.scoringDimensions || []

  const scores = scoringDimensions.map(d => d.score)
  const total = Math.round(scores.reduce((acc, x) => acc + (x || 0), 0) * 100) / 100

  isDark = !!isDark
  const { axisNames, axisValues } = scoringDimensions.reduce(
    (acc, cur) => {
      acc.axisNames.push(cur.name)
      acc.axisValues.push(cur.actual || 0)
      return acc
    },
    { axisNames: [], axisValues: [] },
  )
  return {
    chart: {
      className: 'spider-chart',
      backgroundColor: styles[isDark].background,
      polar: true,
    },
    title: {
      text: '',
    },
    xAxis: {
      categories: axisNames,
      tickmarkPlacement: 'on',
      lineWidth: 0,
      labels: {
        style: {
          color: styles[isDark].textColor,
        },
      },
    },
    yAxis: {
      gridLineInterpolation: 'polygon',
      min: 0,
      max: 10,
      tickPositions: [0, 2, 4, 6, 8, 10],
      tickInterval: 2,
      labels: {
        style: {
          color: styles[isDark].textColor,
        },
      },
    },
    tooltip: {
      format: '<span>{key}: <b>{point.y:,.2f}</b></span>',
    },
    series: [
      {
        data: axisValues,
        pointPlacement: 'on',
      },
    ],
    legend: {
      className: 'spider-chart-legend',
      symbolWidth: 0,
      style: {
        color: styles[isDark].textColor,
      },
      events: {
        itemClick: () => false,
      },
      labelFormatter: function () {
        return `<b>${i18next.t('chart.totalScoreLabel', 'Weighted score')}: ${total}</b>`
      },
      layout: 'vertical',
      itemStyle: {
        color: styles[isDark].textColor,
      },
    },
    pane: {
      background: null,
      size: '90%',
    },
    colors: ['#FFAAAA', '#D46A6A', '#AA3939', '#801515', '#550000'],
    responsive: {
      rules: [
        {
          condition: {
            maxWidth: 500,
          },
          chartOptions: {
            title: {
              x: 0,
            },
            legend: {
              align: 'center',
              verticalAlign: 'bottom',
              layout: 'horizontal',
            },
            pane: {
              size: '70%',
            },
          },
        },
      ],
    },
    exporting: {
      enabled: false, // to hide menu with exporting actions
      fallbackToExportServer: false,
    },
    credits: {
      enabled: false,
    },
  }
}

export async function getHigchartAsPng(actionCard, isDark) {
  try {
    const settings = getHighchartOptions(actionCard, isDark)

    if (!settings) {
      return null
    }

    const chartContainer = document.createElement('div')
    const chart = Highcharts.chart(chartContainer, settings)
    const svg = chart.exporting.getSVGForExport(chart.exporting.options, {})
    const chartWidth = chart.chartWidth
    const chartHeight = chart.chartHeight
    chart.destroy()
    chartContainer.remove()

    const url = URL.createObjectURL(new Blob([svg], { type: 'image/svg+xml' }))

    const img = new Image()
    img.style.width = `${chartWidth}px`
    img.style.height = `${chartHeight}px`

    const promise = new Promise((resolve, reject) => {
      img.onload = () => {
        try {
          const canvas = document.createElement('canvas')
          canvas.width = img.width
          canvas.height = img.height

          canvas.getContext('2d').drawImage(img, 0, 0)
          canvas.toBlob(blob => {
            canvas.remove()
            img.remove()
            resolve(blob)
          }, 'image/png')
        } catch (ex) {
          console.error(ex)
          reject(ex)
        }
      }
    })
    img.src = url

    document.body.appendChild(img)

    return await promise
  } catch (ex) {
    console.error(ex)
  }
}
